<template>
  <div>
    <div class="audit2 page landscape">
      <Logo />
      <div class="flex">
        <div class="info">
          <div class="container">
            <center><h1>Strategiczny link building</h1></center>
            <h4>
              Na czym polega?
            </h4>
            <ul>
              <li>
                Strategia linkowania dostosowana do etapu, na którym znajduje
                się strona
              </li>
              <li>Dobór domen na bazie wieloletniego doświadczenia</li>
              <li>Tworzenie treści wysokiej jakości</li>
            </ul>
            <h4>
              Zalety:
            </h4>
            <ul>
              <li>Linki z zaufanych stron o wysokich wskaźnikach SEO</li>
              <li>Dywersyfikacja źródeł pozyskiwania linków</li>
              <li>
                Pozyskiwane linki nie zaszkodzą Twojej witrynie, bo dbamy o
                bezpieczeństwo
              </li>
              <li>
                Monitoring przyrostu linków, zrzekanie się tych, które mogą być
                potencjalnym zagrożeniem
              </li>
            </ul>
            <center>
              <img
                src="/icon2.png"
                alt=""
                srcset=""
                style="
                  width: 50%;
                  margin: 0;
                  padding: 0;
                  margin-left: 0px;
                  margin-top: -40px;
                "
              />
            </center>
          </div>
        </div>
        <div class="bg-image">
          <img src="/col6.jpg" alt="" srcset="" />
          <div class="overlay"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'

export default {
  name: 'Audit2',
  components: {
    Logo,
  },
  props: {
    msg: String,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.audit2 {
  color: #000 !important;
  text-align: left;
}

.container {
  margin-top: 100px;
}
</style>
